<template>
  <div class="work-evaluate">
    <works-com :data-list="userList" @ScrollCreate="ScrollCreate" @pullingUp="scrollTarget" @showPicture="showPicture" @onVideoPlay="onVideoPlay">
      <template v-slot:workShow="ctx1">
        <div class="foot-box">
          <div class="remark">
            <div class="browse-count"> 浏览{{ ctx1.data.item.visit }}次 </div>
            <div class="praise-count" @click="triggerPraise(ctx1.data.item, ctx1.data.index)"> 
              <img :src="praiseImg(ctx1.data.item.praise_state)" alt=""> {{ ctx1.data.item.praise }} 
            </div>
          </div>
          <div v-if="ctx1.data.item.comments.length" class="comments">
            <div v-for="(item_com, index_com) in ctx1.data.item.comments" :key="'com'+index_com" class="comment">
              <div class="com-name"> {{ item_com.name }}:</div>
              <div class="com-text"> {{ item_com.comment }} </div>
            </div>
          </div>
        </div> 
      </template>
    </works-com>
  </div>
</template>

<script>
  import { getArticleList, addflower, getShareDetail } from '@api/article'

  import WorksCom from '@components/content/workBox/worksCom'

  export default {
    name: 'WorkEvaluate',
    components: {
      WorksCom
    },
    data() {
      return {
        userList: [],
        limit: 8,
        page: 1,
        scroll: null
      }
    },
    methods: {
      getProductions() { //获取数据
        let param = { page: this.page, limit: this.limit }
        getArticleList(this.$route.params.uid, param).then(res => {
          let result = res.data;
          if (result.length) {
            for (let item of result) {
              if (item.status) {
                this.userList.push({
                  id: item.id,
                  name: item.student_name,
                  pic: item.headimgurl || require('@assets/images/1.jpg') ,
                  title: item.title,
                  evalPic: item.slider_image,
                  time: item.add_time,
                  praise: item.flowers,
                  praise_state: item.isflower,
                  stars: item.stars,
                  visit: Number(item.visit),
                  status: item.status,
                  comments: this.newEeply(item.reply),
                  visitHistory: false
                })
              }
            }
            this.page++; //获取到数据，下次操作
            if (this.scroll) {
              this.scroll.refresh();
              this.scroll.finishPullUp();
            }
          }else {
            this.$Message.success('已经到底啦');
          }
        })
      },
      triggerPraise(item, index) { //触发点赞
        if (!this.userList[index].praise_state) {
          this.userList[index].praise++;
          this.userList[index].praise_state = true;
          addflower({id: item.id});
        }else {
          this.$Message.success('你已点赞过了');
        }
      },
      praiseImg(state) { //点赞图标
        return state ? require('@assets/images/common/praise02.png') : require('@assets/images/common/praise01.png');
      },
      addVisit(status, id) {
        if (!status) {
          let index = this.passIdOfIndex(id);
          if (index !== -1) {
            this.userList[index].visitHistory = true;
            this.userList[index].visit++;
            getShareDetail(id);
          }
        }
      },
      showPicture(data) { //展示图片
        this.addVisit(data.history, data.id);
      },
      onVideoPlay(data) { //播放器播放
        this.addVisit(data.history, data.id);
      },
      passIdOfIndex(id) { //id获取索引
        return this.userList.findIndex(item => Number(item.id) === Number(id));
      },
      newEeply(reply) { //新reply
        let arr = [];
        if (reply && Array.isArray(reply) && reply.length) {
          arr = reply;
        }else if (reply && typeof(reply) === 'object') {
          for (let prop in reply) {
            let item = reply[prop];
            arr.push({
              name: item.nickname,
              pic: item.headimgurl,
              comment: item.comment,
              time: item.add_time,
              uid: item.uid
            });
          }
        }
        return arr;
      },
      scrollTarget() { //接受上拉操作
        this.getProductions();
      },
      ScrollCreate(scroll) { //复制scroll
        this.scroll = scroll;
      }
    },
    mounted() {
      this.getProductions();
    }
  }
</script>

<style scoped>
  .work-evaluate {
    width: 100vw;
    height: 100vh;
    position: relative;
    background-color: #f5f5f5;
    padding: 0 0.2rem;
    overflow-y: scroll;
  }
        .remark {
          display: flex;
          justify-content: space-between;
          color: #888888;
          margin-top: 0.15rem;
        }
          .praise-count {
            margin-right: 0.2rem;
          }
          .praise-count img {
            width: 0.3rem;
            width: 0.45rem;
            vertical-align: bottom;
          }
        .comments {
          margin-top: 0.1rem;
          padding-top: 0.05rem;
          border-top: 1px solid #d4d4d4;
        }
          .comment {
            display: flex;
            margin-top: 0.1rem;
          }
            .com-name {
              margin-right: 0.1rem;
            }
            .com-text {
              color: #97999a;
            }
    .show-box {
      display: flex;
      align-items: center;
    }
    .show-content {
      width: 100%;
    }
</style>